function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  rx: 21,
  fill: "#FA6358",
  fillOpacity: 0.15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.52 18.347C37.7 15.56 33.982 14 30 14c-8.197 0-14.867 6.67-14.867 14.867 0 2.622.697 5.177 1.99 7.434L15 44l7.898-2.057A14.69 14.69 0 0030 43.768c8.197-.034 14.867-6.704 14.867-14.9 0-3.95-1.56-7.7-4.347-10.52zM30 41.246c-2.224 0-4.414-.598-6.305-1.726l-.465-.266-4.68 1.228 1.262-4.546-.299-.465a12.406 12.406 0 01-1.891-6.57c0-6.804 5.542-12.346 12.378-12.346 3.285 0 6.405 1.295 8.728 3.618a12.324 12.324 0 013.617 8.76c0 6.77-5.542 12.313-12.345 12.313zm6.77-9.26c-.365-.198-2.19-1.094-2.555-1.194-.332-.133-.598-.2-.83.2-.232.364-.962 1.194-1.161 1.46-.233.232-.432.265-.797.099-.365-.2-1.56-.564-2.987-1.859-1.095-.995-1.858-2.19-2.057-2.588-.233-.365-.033-.564.166-.763.166-.166.365-.432.564-.664.199-.232.232-.365.365-.63.133-.233.066-.465-.033-.664-.1-.2-.83-2.025-1.162-2.755-.299-.73-.597-.63-.83-.63h-.696c-.233 0-.664.1-.996.464-.332.365-1.294 1.262-1.294 3.087 0 1.825 1.327 3.584 1.526 3.85.2.232 2.622 4.015 6.339 5.608.896.398 1.593.597 2.124.796.896.299 1.692.232 2.356.133.73-.1 2.19-.896 2.522-1.759.299-.863.299-1.626.232-1.759-.166-.166-.431-.265-.796-.431z",
  fill: "#444"
});

function SvgWhatsappinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgWhatsappinline;